import React from "react";
import { LocalizationHelperInstance } from "utils/helpers";
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import IncomingInvoiceUpdatePaymentFormContainer from "./forms/updatePaymentFormContainer";
import { TranslationKeys } from "translations";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { IncomingInvoiceFormTypes } from "models/formTypes";
import { IncomingInvoiceUpdatePaymentFormContainerProps } from "models/propTypes/incomingInvoicePropTypes";

function useUpdatePaymentDialog() {
  return (
    invoice: IncomingInvoiceUpdatePaymentFormContainerProps,
    onActionSuccess?: (values: IncomingInvoiceFormTypes.UpdatePayment) => void
  ): DialogProps => ({
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.EditPayment),
    subTitle: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PaymentSettings),
    titleIcon: IconDefinitionConstants.WTransactions,
    dialogType: DialogEnums.DialogType.Content,
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SaveChanges),
        successMessage: TranslationKeys.IncomingInvoice.PaymentUpdatedSuccessMessage,
      },
    ],
    children: (
      <IncomingInvoiceUpdatePaymentFormContainer
        invoiceId={invoice.invoiceId}
        isAlreadyPaid={invoice.isAlreadyPaid}
        paymentDate={invoice.paymentDate}
      />
    ),
    onSubmit: onActionSuccess,
    maxWidth: "sm",
  });
}

export default useUpdatePaymentDialog;
